import { render } from "./px-questionary-range.vue?vue&type=template&id=9ca540d6&scoped=true&ts=true"
import script from "./px-questionary-range.vue?vue&type=script&lang=ts"
export * from "./px-questionary-range.vue?vue&type=script&lang=ts"

import "./px-questionary-range.vue?vue&type=style&index=0&id=9ca540d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca540d6"]])

export default __exports__